/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  Score,
  ScoreAnswer,
  ValidationErrorResponse,
} from '../models';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ScoreFromJSON,
    ScoreToJSON,
    ScoreAnswerFromJSON,
    ScoreAnswerToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models';

export interface ScoresAnswersListRequest {
    attemptId: string;
    categoryId: string;
}

export interface ScoresCsvRetrieveRequest {
    attemptId: string;
}

export interface ScoresListRequest {
    attemptId: string;
}

export interface ScoresToggleIsCorrectUpdateRequest {
    attemptId: string;
    questionId: string;
}

/**
 * 
 */
export class ScoresApi extends runtime.BaseAPI {

    /**
     */
    async scoresAnswersListRaw(requestParameters: ScoresAnswersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ScoreAnswer>>> {
        if (requestParameters.attemptId === null || requestParameters.attemptId === undefined) {
            throw new runtime.RequiredError('attemptId','Required parameter requestParameters.attemptId was null or undefined when calling scoresAnswersList.');
        }

        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling scoresAnswersList.');
        }

        const queryParameters: any = {};

        if (requestParameters.attemptId !== undefined) {
            queryParameters['attemptId'] = requestParameters.attemptId;
        }

        if (requestParameters.categoryId !== undefined) {
            queryParameters['categoryId'] = requestParameters.categoryId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/scores/answers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ScoreAnswerFromJSON));
    }

    /**
     */
    async scoresAnswersList(requestParameters: ScoresAnswersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ScoreAnswer>> {
        const response = await this.scoresAnswersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async scoresCsvRetrieveRaw(requestParameters: ScoresCsvRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.attemptId === null || requestParameters.attemptId === undefined) {
            throw new runtime.RequiredError('attemptId','Required parameter requestParameters.attemptId was null or undefined when calling scoresCsvRetrieve.');
        }

        const queryParameters: any = {};

        if (requestParameters.attemptId !== undefined) {
            queryParameters['attemptId'] = requestParameters.attemptId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/scores/csv/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async scoresCsvRetrieve(requestParameters: ScoresCsvRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.scoresCsvRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async scoresListRaw(requestParameters: ScoresListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Score>>> {
        if (requestParameters.attemptId === null || requestParameters.attemptId === undefined) {
            throw new runtime.RequiredError('attemptId','Required parameter requestParameters.attemptId was null or undefined when calling scoresList.');
        }

        const queryParameters: any = {};

        if (requestParameters.attemptId !== undefined) {
            queryParameters['attemptId'] = requestParameters.attemptId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/scores/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ScoreFromJSON));
    }

    /**
     */
    async scoresList(requestParameters: ScoresListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Score>> {
        const response = await this.scoresListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async scoresToggleIsCorrectUpdateRaw(requestParameters: ScoresToggleIsCorrectUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.attemptId === null || requestParameters.attemptId === undefined) {
            throw new runtime.RequiredError('attemptId','Required parameter requestParameters.attemptId was null or undefined when calling scoresToggleIsCorrectUpdate.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling scoresToggleIsCorrectUpdate.');
        }

        const queryParameters: any = {};

        if (requestParameters.attemptId !== undefined) {
            queryParameters['attemptId'] = requestParameters.attemptId;
        }

        if (requestParameters.questionId !== undefined) {
            queryParameters['questionId'] = requestParameters.questionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/scores/toggle_is_correct/`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async scoresToggleIsCorrectUpdate(requestParameters: ScoresToggleIsCorrectUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.scoresToggleIsCorrectUpdateRaw(requestParameters, initOverrides);
    }

}
